var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrawer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41667 16.9167H33.5833V4.41667H4.41667V16.9167ZM37.75 2.33333V35.6667C37.75 36.2192 37.5305 36.7491 37.1398 37.1398C36.7491 37.5305 36.2192 37.75 35.6667 37.75H2.33333C1.7808 37.75 1.25089 37.5305 0.860194 37.1398C0.469493 36.7491 0.25 36.2192 0.25 35.6667V2.33333C0.25 1.7808 0.469493 1.25089 0.860194 0.860194C1.25089 0.469493 1.7808 0.25 2.33333 0.25H35.6667C36.2192 0.25 36.7491 0.469493 37.1398 0.860194C37.5305 1.25089 37.75 1.7808 37.75 2.33333ZM33.5833 21.0833H4.41667V33.5833H33.5833V21.0833ZM8.58333 25.25H14.8333V29.4167H8.58333V25.25ZM8.58333 8.58333H14.8333V12.75H8.58333V8.58333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawer);
export default __webpack_public_path__ + "static/media/drawer.b04c4964ad38aaabe4ebf9625edfae5c.svg";
export { ForwardRef as ReactComponent };